export default __webpack_public_path__ + "static/2616-114b991a521a8bb7e381feee50f4d7fb.jpeg";